export var defaultState = null;